export default __webpack_public_path__ + "static/media/pantry1-afterG-1440w.74062d28.avif";